<template>
  <div class="t-modal" :class="[{ 't-modal--fullscreen': fullscreen }]" :style="{ zIndex }">
    <transition name="fade" appear>
      <div v-if="visible" class="t-modal__backdrop"></div>
    </transition>
    <transition :name="transition" appear>
      <div v-if="visible" class="t-modal__inner" @click.self="handleBackdropClick">
        <div class="t-modal__main">
          <div v-if="showHeader" class="t-modal__header">
            <slot name="header"></slot>
            <icon-close
              v-if="fullscreen"
              class="t-modal__close"
              @click="$emit('update:visible', false)"
            ></icon-close>
          </div>
          <div class="t-modal__body">
            <slot></slot>
          </div>
          <icon-close
            v-if="!fullscreen"
            class="t-modal__close t-modal__close--outside"
            @click="handleClose"
          ></icon-close>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import modalManager from 'javascript/helpers/modalManager'
import IconClose from 'assets/icons/close.svg?inline'

export default {
  name: 'TModal',

  components: {
    IconClose
  },

  props: {
    visible: Boolean,
    fullscreen: Boolean,
    hideHeader: Boolean,
    noCloseOnBackdrop: Boolean,
    transition: { type: String, default: '' }
  },

  data() {
    return {
      zIndex: 1000
    }
  },

  computed: {
    showHeader() {
      if (this.hideHeader) return false
      if (this.fullscreen) return true

      return !!this.$slots.header
    }
  },

  watch: {
    visible: {
      handler(value) {
        // call getZIndex to ensure that we have highest z-index when the modal is open
        if (value) this.zIndex = modalManager.getZIndex()
      },
      immediate: true
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$root.$el.appendChild(this.$el)
    })

    this.$once('hook:beforeDestroy', () => {
      this.$el.parentNode?.removeChild(this.$el)
    })
  },

  methods: {
    handleBackdropClick() {
      if (this.noCloseOnBackdrop) return

      this.$emit('update:visible', false)
    },

    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>
